<div class="my-4">
  @if (this.multiline()) {
    <soft-multiline-input
      class="w-full"
      softFocus
      [placeholder]="placeholder()"
      [(value)]="textValue"
      [lines]="7"
      (softVirtualKeyboardEnter)="this.resolve(this.textValue()!)"
      (keydown.enter)="this.resolve(this.textValue()!)"
    ></soft-multiline-input>
  } @else {
    <soft-input
      class="w-full"
      softFocus
      [placeholder]="placeholder()"
      [(value)]="textValue"
      (softVirtualKeyboardEnter)="this.resolve(this.textValue()!)"
      (keydown.enter)="this.resolve(this.textValue()!)"
    />
  }
</div>

<div class="flex flex-row gap-2 mt-2 w-full">
  <button class="soft-button secondary w-full h-14" (click)="this.resolve('CANCEL')">
    Abbrechen
  </button>
  <button
    class="soft-button accent w-full h-14"
    (click)="this.resolve(this.textValue()!)"
    [disabled]="!textValue()"
  >
    {{ saveButtonText() ?? 'Speichern' }}
  </button>
</div>
